export class KeyCodeUtil {
    static charBackspace: number = 8; // backspace
    static charTab: number = 9; // tab
    static charEnter: number = 13; // enter
    static charShift: number = 16;// shift
    static charCtrl: number = 17; // ctrl
    static charAlt: number = 18;// alt
    static charPauseBreak: number = 19;// pause/break
    static charCapsLock: number = 20;  // caps lock
    static charEscape: number = 27; // escape
    static charPageUp: number = 33;  // page up, to avoid displaying alternate character and confusing people	         
    static charPageDown: number = 34; // page down
    static charEnd: number = 35; // end
    static charHome: number = 36; // home
    static charLeftArrow: number = 37; // left arrow
    static charUpArrow: number = 38; // up arrow
    static charRightArrow: number = 39; // right arrow
    static charDownArrow: number = 40; // down arrow
    static charInsert: number = 45; // insert
    static charDelete: number = 46; // delete
    static char0: number = 48; // 0
    static char1: number = 49; // 1
    static char2: number = 50; // 2
    static char3: number = 51; // 3
    static char4: number = 52; // 4
    static char5: number = 53; // 5
    static char6: number = 54; // 6
    static char7: number = 55; // 7
    static char8: number = 56; // 8
    static char9: number = 57; // 9
    static charA: number = 65; // A
    static charB: number = 66; // B
    static charC: number = 67; // C
    static charD: number = 68; // D
    static charE: number = 69; // E
    static charF: number = 70; // F
    static charG: number = 71; // G
    static charH: number = 72; // H
    static charI: number = 73; // I
    static charJ: number = 74; // J
    static charK: number = 75; // K
    static charL: number = 76; // L
    static charM: number = 77; // M
    static charN: number = 78; // N
    static charO: number = 79; // O
    static charP: number = 80; // P
    static charQ: number = 81; // Q
    static charR: number = 82; // R
    static charS: number = 83; // S
    static charT: number = 84; // T
    static charU: number = 85; // U
    static charV: number = 86; // V
    static charW: number = 87; // W
    static charX: number = 88; // X
    static charY: number = 89; // Y
    static charZ: number = 90; // Z
    static charLeftWindow: number = 91; // left window
    static charRightWindow: number = 92; // right window
    static charSelectKey: number = 93; // select key
    static charnumpad0: number = 96; // numpad 0
    static charnumpad1: number = 97; // numpad 1
    static charnumpad2: number = 98; // numpad 2
    static charnumpad3: number = 99; // numpad 3
    static charnumpad4: number = 100; // numpad 4
    static charnumpad5: number = 101; // numpad 5
    static charnumpad6: number = 102; // numpad 6
    static charnumpad7: number = 103; // numpad 7
    static charnumpad8: number = 104; // numpad 8
    static charnumpad9: number = 105; // numpad 9
    static charMultiply: number = 106; // multiply
    static charAdd: number = 107; // add
    static charSubtract: number = 109; // subtract
    static charDecimalPoint: number = 110; // decimal point
    static charDivide: number = 111; // divide
    static charF1: number = 112; // F1
    static charF2: number = 113; // F2
    static charF3: number = 114; // F3
    static charF4: number = 115; // F4
    static charF5: number = 116; // F5
    static charF6: number = 117; // F6
    static charF7: number = 118; // F7
    static charF8: number = 119; // F8
    static charF9: number = 120; // F9
    static charF10: number = 121; // F10
    static charF11: number = 122; // F11
    static charF12: number = 123; // F12
    static charNumLock: number = 144; // num lock
    static charScrollLock: number = 145; // scroll lock
    static charSemiColon: number = 186; // semi-colon
    static charEqualSign: number = 187;// equal-sign
    static charComma: number = 188; // comma
    static charDash: number = 189; // dash
    static charPeriod: number = 190; // period
    static charForwardSlash: number = 191; // forward slash
    static charGraveAccent: number = 192; // grave accent
    static charOpenBraket: number = 219; // open bracket
    static charBackSlash: number = 220; // back slash
    static charCloseBracket: number = 221; // close bracket
    static charSingleQuote: number = 222; // single quote
}


// WEBPACK FOOTER //
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/app/infrastructure/keyCode.util.ts